module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY15.e3dd419a.jpg";